import { useState } from 'react';

import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { formatErrorArray } from 'utils/request.utils';

interface DeleteProps {
  endpoint: string;
  redirectUrl: string;
}

export const useDelete = ({ endpoint, redirectUrl }: DeleteProps) => {
  const [errors, setErrors] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();

  return {
    errors,
    isDeleting,
    onDelete: async () => {
      try {
        setIsDeleting(true);
        await axios.delete(endpoint);
        setIsDeleting(false);
        setErrors(null);
        navigate(redirectUrl);
      } catch (e: any) {
        setIsDeleting(false);
        setErrors(formatErrorArray(e));
      }
    },
  };
};
